import React, { useEffect, useState } from "react";
import {
    faHtml5,
    faCss3Alt,
    faJs,
    faReact,
    faNodeJs,
    faLinkedin,
    faLinkedinIn,
    faGithub,
    faAws,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { gsap } from "gsap";
import { useRef } from "react";
import { faAngleLeft, faAngleRight, faEnvelope, faGlassMartiniAlt, faMailBulk, faMailForward } from "@fortawesome/free-solid-svg-icons";

function Home() {

    function scrolled(event) {
        // alert("scrolled");

        scale += event.deltaX * 0.1;
        const scrollMax = 200;
        scale = Math.min(Math.max(0, scale), scrollMax);

        console.log(Math.trunc(scale / 2) + "%");

        const p = document.getElementById("progress");
        p.style.width = Math.trunc(scale / 2) + "%";
        const scrollSegment = scrollMax / 4;
        const breaks = [
            scrollSegment,
            scrollSegment * 2,
            scrollSegment * 3,
            scrollSegment * 4,
        ];


        if (scale < breaks[0]) {
            console.log(1);
            // document.querySelector(".about1").classList.remove("hidden");
            // document.querySelector(".about2").classList.add("hidden");
            // document.querySelector(".about3").classList.add("hidden");
            // document.querySelector(".about4").classList.add("hidden");
            document.querySelector(".about1").style = "opacity: 100;";
            document.querySelector(".about2").style = "opacity: 0;";
            document.querySelector(".about3").style = "opacity: 0;";
            document.querySelector(".about4").style = "opacity: 0;";
        } else if (scale < breaks[1]) {
            console.log(2);
            // document.querySelector(".about1").classList.add("hidden");
            // document.querySelector(".about2").classList.remove("hidden");
            // document.querySelector(".about3").classList.add("hidden");
            // document.querySelector(".about4").classList.add("hidden");
            document.querySelector(".about1").style = "opacity: 0;";
            document.querySelector(".about2").style = "opacity: 100;";
            document.querySelector(".about3").style = "opacity: 0;";
            document.querySelector(".about4").style = "opacity: 0;";
        } else if (scale < breaks[2]) {
            console.log(3);
            // document.querySelector(".about1").classList.add("hidden");
            // document.querySelector(".about2").classList.add("hidden");
            // document.querySelector(".about3").classList.remove("hidden");
            // document.querySelector(".about4").classList.add("hidden");
            document.querySelector(".about1").style = "opacity: 0;";
            document.querySelector(".about2").style = "opacity: 0;";
            document.querySelector(".about3").style = "opacity: 100;";
            document.querySelector(".about4").style = "opacity: 0;";
        } else {
            console.log(4);
            // document.querySelector(".about1").classList.add("hidden");
            // document.querySelector(".about2").classList.add("hidden");
            // document.querySelector(".about3").classList.add("hidden");
            // document.querySelector(".about4").classList.remove("hidden");
            document.querySelector(".about1").style = "opacity: 0;";
            document.querySelector(".about2").style = "opacity: 0;";
            document.querySelector(".about3").style = "opacity: 0;";
            document.querySelector(".about4").style = "opacity: 100;";
        }
    }

    let scale = 1;

    const handleOnMoouseMove = (e) => {
        const { currentTarget: target } = e;

        const rect = target.getBoundingClientRect(),
            x = e.clientX - rect.left,
            y = e.clientY - rect.top;

        target.style.setProperty("--mouse-x", `${x}px`);
        target.style.setProperty("--mouse-y", `${y}px`);
    };

    for (const board of document.querySelectorAll(".board")) {
        board.onmousemove = (e) => handleOnMoouseMove(e);
    }

    function myFunction() {
        // console.log("SSSS");
        // const aboutdiv = document.querySelector(".aboutdiv");
        // aboutdiv.onwheel = scrolled;
        // var leftOffset = document.getElementById("about").scrollLeft;
        // console.log(leftOffset);
        // const breaks = [380, 760, 1140];
        // if (leftOffset < breaks[0]) {
        // 	console.log(0);
        // 	document.querySelector(".about1").classList.remove("hidden");
        // } else if (leftOffset < breaks[1]) {
        // 	document.querySelector(".about2").classList.remove("hidden");
        // 	console.log(1);
        // } else if (leftOffset < breaks[2]) {
        // 	document.querySelector(".about3").classList.remove("hidden");
        // 	console.log(2);
        // } else {
        // 	document.querySelector(".about4").classList.remove("hidden");
        // 	console.log(3);
        // }
    }

    let aboutNav = () => {};

    let styleBuildStuff = () => {
        // let angle = 45;
        let angle = 135 / 20;
        let rot = 67.5;
        var elemWidth = document.querySelector(".ellipse").clientWidth;
        console.log(elemWidth);
        for (const letter of document.querySelectorAll(".arcText")) {
            letter.style = `transform: rotate(${rot}deg) translate(0px, ${
                elemWidth * 0.38
            }px);`;
            rot -= angle;
            console.log(rot);
        }
    };

    let ellipse1 = useRef(null);
    let ellipse3 = useRef(null);
    let purplebg = useRef(null);

    let gsapAnimations = () => {
        gsap.fromTo(
            ellipse1,
            { x: -200, ease: "expo" },
            { x: 0, ease: "expo", duration: 2 }
        );
        gsap.fromTo(
            ellipse3,
            { x: 200, ease: "expo" },
            { x: 0, ease: "expo", duration: 2 }
        );

        // gsap.fromTo(purplebg, { x: 0 }, { x: -100, duration: 1 });
    };

    useEffect(() => {
        styleBuildStuff();
        gsapAnimations();
    }, []);

    return (
        <div className="home lg:h-screen max-sm: py-40" id="home">
            <div className="w-fit h-full mx-auto relative flex flex-col lg:flex-row lg:overflow-x-visible overscroll-x-contain justify-center items-center lg:-space-x-4 max-sm:gap-5">
                <div
                    ref={(el) => {
                        ellipse1 = el;
                    }}
                    className="ellipse ellipse-1 lg:w-[20rem] lg:h-[42rem]  w-11/12 h-fit flex flex-col justify-center items-center"
                >
                    <div className="z-30 w-full h-full border-[0.8px] border-gray-400 board overflow-hidden rounded-full relative bg-black_bg text-white flex flex-col justify-center items-center hover:bg-grey_bg group">
                        <h1 className="font-Sawarabi_Mincho text-[28px] group-hover:text-[32px] transition-all duration-300 max-sm:p-5 max-md:p-5 text-accent">
                            Shreya Harlapur
                        </h1>
                        <h2 className="tracking-[.30em] group-hover:tracking-[.50em] font-bold pt-4 transition-all duration-200 max-sm:pt-5 max-md:pt-5 text-base text-accent">
                            TECHNICAL PROJECT
                        </h2>
                        <h2 className="tracking-[.30em] group-hover:tracking-[.50em] group-hover:pb-2 font-bold -mt-1 transition-all duration-200 max-sm:pb-5 max-md:pb-5 text-base text-accent">
                            MANAGER
                        </h2>
                        <div className="my-10 flex items-center gap-2">
                            <FontAwesomeIcon 
                                icon={faLinkedin}
                                className="h-6 text-blue-500 cursor-pointer p-2 group-hover:h-10 transition-all duration-300"
                                onClick={() => window.open("https://www.linkedin.com/in/shreya-harlapur-771327204/", "_blank")}
                            />
                            {/* <FontAwesomeIcon 
                                icon={faGithub}
                                className="h-6 text-white cursor-pointer p-2 group-hover:h-10 transition-all duration-300"
                                onClick={() => window.open("https://github.com/SamEarth79", "_blank")}
                            /> */}
                            <FontAwesomeIcon 
                                icon={faEnvelope}
                                className="h-6 text-white cursor-pointer p-2 group-hover:h-10 transition-all duration-300"
                                onClick={() => window.open("mailto:shreyaaatwork@gmail.com", "_blank")}
                            />
                        </div>
                        {/* <div className="absolute bottom-[12.5rem] text-accent rounded-full max-sm:hidden max-md:hidden">
                            <div className="relative flex">
                                <h3 className="arcText absolute">I</h3>
                                <h3 className="arcText absolute">{}</h3>
                                <h3 className="arcText absolute">l</h3>
                                <h3 className="arcText absolute">i</h3>
                                <h3 className="arcText absolute">k</h3>
                                <h3 className="arcText absolute">e</h3>
                                <h3 className="arcText absolute">{}</h3>
                                <h3 className="arcText absolute">t</h3>
                                <h3 className="arcText absolute">o</h3>
                                <h3 className="arcText absolute">{}</h3>
                                <h3 className="arcText absolute">b</h3>
                                <h3 className="arcText absolute">u</h3>
                                <h3 className="arcText absolute">i</h3>
                                <h3 className="arcText absolute">l</h3>
                                <h3 className="arcText absolute">d</h3>
                                <h3 className="arcText absolute">{}</h3>
                                <h3 className="arcText absolute">s</h3>
                                <h3 className="arcText absolute">t</h3>
                                <h3 className="arcText absolute">u</h3>
                                <h3 className="arcText absolute">f</h3>
                                <h3 className="arcText absolute">f</h3>
                            </div>
                        </div> */}
                    </div>
                    {/* <div className="light h-[300px] w-[400px] bg-gradient-to-t from-white to-white_trans absolute bottom-8 z-40"></div> */}
                </div>
                <div className="ellipse ellipse-2 lg:w-[20rem] lg:h-[42rem] w-11/12 h-fit flex flex-col justify-center items-center group">
                    <div
                        ref={(el) => {
                            purplebg = el;
                        }}
                        className="purplebg z-20 w-full h-full grid place-content-end border-[0.8px] border-gray-400 overflow-hidden relative rounded-full  bg-no-repeat "
                    >
                                {/* <div className="bg-white aspect-square rounded-full w-11/12 mx-auto absolute bottom-0 left-1/2 -translate-x-1/2 z-40"></div> */}
                                <img
                                    src={require("./stock/reyyyygpt-removebg-preview.png")}
                                    className="z-50 relative h-[38em] object-cover"
                                    alt="me"
                                />
                                {/* <div className="bg-inherit border-[0.4rem] border-b-accent border-t-transparent border-l-transparent border-r-transparent aspect-square rounded-full w-11/12 absolute bottom-0 left-1/2 -translate-x-1/2 z-50"></div> */}
                                {/* <div className="bg-inherit border-[0.4rem] border-b-accent border-t-transparent border-l-transparent border-r-transparent aspect-square rounded-full w-11/12 absolute bottom-0 left-1/2 -translate-x-1/2 z-50 rotate-[22.5deg]"></div> */}
                                {/* <div className="bg-inherit border-[0.4rem] border-b-accent border-t-transparent border-l-transparent border-r-transparent aspect-square rounded-full w-11/12 absolute bottom-0 left-1/2 -translate-x-1/2 z-50 rotate-[-22.5deg]"></div> */}
                        {/* <div className="bg-white aspect-square w-40 rounded-full absolute bottom-10 translate-x-1/2">
							<img
								src={require("./stock/meee.png")}
								className="absolute bottom-1"
								alt="me"
							/>
						</div> */}
                    </div>
                </div>
                <div
                    ref={(el) => {
                        ellipse3 = el;
                    }}
                    className="ellipse ellipse-3 lg:w-[20rem] lg:h-[42rem]  w-11/12 h-fit flex aboutdiv relative flex-col justify-center items-center overflow-x-hidden "
                    onClick={myFunction}
                    id={"about"}
                    onWheel={scrolled}
                >
                    <div className="w-full h-full flex lg:hidden absolute z-50 px-2 text-white justify-between items-center">
                        <p className="text-xl nav_left" onClick={aboutNav}>
                            O
                        </p>
                        <p className="text-xl nav_right" onClick={aboutNav}>
                            O
                        </p>
                    </div>
                    <div className="bg-black_bg h-20 w-[20.1rem] absolute overflow-x-hidden"></div>
                    <div className="z-10 w-full h-full max-sm:h-fit border-[0.8px] border-gray-400 board overflow-hidden relative rounded-full bg-black_bg text-white lg:text-right lg:px-8 lg:py-20 hover:bg-grey_bg group">
                        <h1 className="max-sm:hidden font-Sawarabi_Mincho text-[40px] group-hover:text-[45px] group-hover:-mt-1 transition-all duration-300 text-accent">
                            About
                        </h1>
                        <h1 className="max-sm:hidden font-Sawarabi_Mincho text-[40px] group-hover:text-[45px] group-hover:-mt-2 transition-all duration-300 text-accent">
                            Me
                        </h1>
                        <p className="max-sm:hidden about1 absolute opacity-100 top-1/2 -translate-y-about_me_translate ml-6 tracking-wider right-10 group-hover:leading-relaxed transition-all duration-300 text-left">
                            Technical Project Manager @Workday leading end-to-end technical project delivery across cross-functional teams. Previously worked at Razorpay and Societe Generale.
                        </p>
                        <div className="max-sm:hidden about2 opacity-0 absolute top-1/2 -translate-y-about_me_translate ml-6 tracking-wider right-10 group-hover:leading-relaxed transition-all duration-300">
                            <ul className="list-disc ml-4 text-left">
                                <li className="mb-1">Microsoft Certified: Azure Cloud (AZ-900 Fundamentals)</li>
                                <li className="mb-1">Business Analysis Fundamentals (Udemy)</li>
                                <li className="mb-1">SkillPath (Coursera)</li>
                                <li className="mb-1">SAE India AeroDesign Aircraft Competition Winner</li>
                            </ul>
                        </div>
                        <p className="max-sm:hidden about3  opacity-0 absolute top-1/2 -translate-y-about_me_translate ml-6 tracking-wider right-10 group-hover:leading-relaxed transition-all duration-300 text-justify">
                            I have a great interest in exploring tech events, as they provide opportunities to learn about emerging technologies, connect with industry professionals, and stay inspired by innovative ideas.
                        </p>
                        <div className="max-sm:hidden about4  opacity-0 absolute top-1/2 -translate-y-about_me_translate ml-6 tracking-wider right-10 group-hover:leading-relaxed transition-all duration-300">
                            Here are some technologies I have been working with:
                            <div className="grid list-none grid-flow-col grid-rows-6 mt-4">
                                    <div className="text-right mr-2">REST APIs</div>
                                    <div className="text-right mr-2">Postman</div>
                                    <div className="text-right mr-2">SQL</div>
                                    <div className="text-right mr-2">Python</div>
                                    <div className="text-right mr-2">React.js</div>
                                    <div className="text-right mr-2">Azure</div>
                                    <div className="text-left">
                                        <FontAwesomeIcon
                                            icon={faHtml5}
                                            className="text-orange-500 h-7"
                                        />
                                    </div>
                                    <div className="text-left">
                                        <img
                                            src={
                                                require("./stock/icons8-next.js.svg")
                                                    .default
                                            }
                                            alt="firebase_logo"
                                            className="h-7"
                                        />
                                    </div>
                                    <div className="text-left">
                                        <FontAwesomeIcon
                                            icon={faAws}
                                            className="text-sky-400 h-7"
                                        />
                                    </div>
                                    <div className="text-left">
                                        <FontAwesomeIcon
                                            icon={faReact}
                                            className="text-sky-400 h-7"
                                        />
                                    </div>
                                    <div className="text-left">
                                        <FontAwesomeIcon
                                            icon={faJs}
                                            className="text-yellow-300 h-7"
                                        />
                                    </div>
                                    <div className="text-left">
                                        <FontAwesomeIcon
                                            icon={faCss3Alt}
                                            className="text-blue-500 h-7"
                                        />
                                    </div>
                            </div>
                        </div>
                        {/* <div className="max-sm:hidden scroll-indicator w-[4.5rem] h-8 absolute bottom-28 left-1/2 -translate-x-1/2 flex items-center opacity-0 group-hover:opacity-50 transition duration-300 px-3 border rounded-full">
                            <div className="scroll-dot h-2 aspect-square rounded-full bg-white"></div>
                        </div> */}
                        <div className="max-sm:hidden scroll-indicator w-[4.5rem] h-8 absolute bottom-28 left-1/2 -translate-x-2/3 flex gap-4 items-center transition duration-300 px-3">
                            <FontAwesomeIcon
                                icon={faAngleLeft}
                                className="text-white h-7 cursor-pointer p-2"
                                onClick={() => {scale -= 50; scrolled({deltaX: -50})}}
                            />
                            <FontAwesomeIcon
                                icon={faAngleRight}
                                className="text-white h-7 cursor-pointer p-2"
                                onClick={() => {scale += 50; scrolled({deltaX: 50})}}
                            />
                        </div>
                        <div className="max-sm:hidden -z-10 absolute bottom-10 w-full flex justify-center left-1/2 -translate-x-1/2 group-hover:bg-transparent">
                            <div className="circle relative w-11/12 aspect-square bg-transparent rounded-full overflow-hidden group-hover:bg-transparent">
                                <div className="segment absolute w-full h-full top-2/3 bg-transparent group-hover:bg-transparent">
                                    <div
                                        className="h-full bg-accent"
                                        id="progress"
                                        style={{
                                            width: Math.trunc(scale) / 2 + "%",
                                        }}
                                    ></div>
                                </div>
                                <div className="innercircle w-[18em] aspect-square absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-black_bg group-hover:bg-grey_bg rounded-full"></div>
                            </div>
                        </div>
                        <div className="lg:hidden overflow-y-scroll w-full h-full flex flex-col p-6 text-white">
                            <div className="text-center relative">
                                <h1 className="hidden font-Sawarabi_Mincho text-3xl">
                                    About Me
                                </h1>
                                <p className="">
                                    I'm a software engineer based in Bangalore,
                                    India. I have a great interest in full stack
                                    development, gaming, youtube and BTS.
                                </p>
                                <p className="hidden">
                                    I'm a Computer Science graduate and
                                    currently working as a software engineer at
                                    Toshiba Software Pvt. Ltd, Bangalore. I work
                                    everyday on Python and C++.
                                </p>
                                <p className="hidden">
                                    I have a great interest in web development,
                                    and have completed an internship in full
                                    stack dev. I keep myself busy with web dev
                                    projects.
                                </p>
                            </div>
                            <div className=""></div>
                        </div>
                    </div>
                    {/* <div class="trapezoid absolute bottom-8 z-50"></div> */}
                </div>
            </div>
            <div className="triangle"></div>
        </div>
    );
}

export default Home;
